import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import React from "react";
import { BOX_SHADOWS, FONTS } from "../../constants";
import { stateType } from "../../state";
import { BoxHeader } from "../Common/BoxHeader";
import { CloudChart } from "./CloudChart";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			display: "flex",
			flexDirection: "column",
			width: "100%",
			// backgroundImage: CHART_COLOR,
			boxShadow: BOX_SHADOWS,
			borderRadius: "10px",
			height: "100%",
			overflow: "hidden",
		},
	})
);

export function CloudBox({ state }: stateType) {
	let classes = useStyles();
	let ndx = state.saveState.topicModeling.varSelected;
	let cloudData =
		state.saveState.dataset.visualizationData[ndx].topicCloudData.cloudData;

	return (
		<div className={classes.container}>
			<BoxHeader
				title={`Most Common Topics`}
				toolTip={"Shows the main topics covered by the your text data."}
				line={true}
				color="black"
			></BoxHeader>
			<div
				style={{
					marginLeft: "auto",
					marginRight: "20px",
					marginTop: "-3px",
				}}
			></div>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					margin: "30px",
				}}
			>
				<CloudChart
					state={state}
					data={cloudData}
					title="Most Common Phrases"
				></CloudChart>
			</div>
		</div>
	);
}
